import React from 'react';
import { Marker } from 'react-google-maps';

const DirectionMapMarker = (props) => {
  const { position, onClick } = props;
  return <Marker position={position} onClick={onClick} />;
};

export default DirectionMapMarker;
